/**
 * Narwhalia backend
 * Swagger API docs for Narwhalia Backend application
 *
 * OpenAPI spec version: 0.9
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GlitterOfferBaseDto } from './glitterOfferBaseDto'
export * from './glitterOfferBaseDto'

export interface GlitterCartItemDto {
	/** quantity of given glitter package in the cart */
	qty: number;
	offer: GlitterOfferBaseDto;
}